import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=06866ed3&"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=06866ed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports